export function getAssetUrl(asset: string): string {
	return `${window.location.origin}/${asset}`;
}
